import { render, staticRenderFns } from "./SiteLayout.vue?vue&type=template&id=7544f978&scoped=true&"
import script from "./SiteLayout.vue?vue&type=script&lang=ts&"
export * from "./SiteLayout.vue?vue&type=script&lang=ts&"
import style0 from "./SiteLayout.vue?vue&type=style&index=0&id=7544f978&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7544f978",
  null
  
)

export default component.exports